import { render, staticRenderFns } from "./showRobDr.vue?vue&type=template&id=1a639bd8&scoped=true"
import script from "./showRobDr.vue?vue&type=script&lang=js"
export * from "./showRobDr.vue?vue&type=script&lang=js"
import style0 from "./showRobDr.vue?vue&type=style&index=0&id=1a639bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a639bd8",
  null
  
)

export default component.exports